module.exports = __webpack_public_path__ + "img/head_icon.862f40f1.svg";